import { JxButton } from '@/JxControls/index';
import { jxScrollbarThin } from '@/JxControls/jxScrollbarStyle';

/**
 * Read-only mermaid source output, with a copy button — paste target is an
 * external mermaid renderer (or the chat), not an in-app render (sequence
 * diagrams don't live on the class-diagram canvas).
 * @param {{ mermaidSource: string, warnings: string[] }} props
 * @returns {JSX.Element|null}
 */
export default function SeqDiaOutputPanel({ mermaidSource, warnings }) {
    if (!mermaidSource) return null;

    const handleCopy = () => {
        navigator.clipboard.writeText(mermaidSource);
    };

    return (
        <div className="usd-seqdia-output">
            {warnings.length > 0 && <div className="usd-import-text">Warnings: {warnings.join('; ')}</div>}
            <textarea className={`usd-seqdia-output-text ${jxScrollbarThin}`} readOnly value={mermaidSource} rows={12} />

            <div className="usd-button-row">
                <JxButton className="jx-button-sm" label="Copy mermaid" onClick={handleCopy} />
            </div>
        </div>
    );
}
